import http from '../../http';
import { SERVER_URL } from '../../config';

export const getPostData = (params) => http.get(`${SERVER_URL}/api-main/v1/posts`, {params : { ...params }});
